// extracted by mini-css-extract-plugin
export var pillWrapper = "_p8-0";
export var showOverflow = "_p8-1";